import { render, staticRenderFns } from "./CustomerFilterPanel.vue?vue&type=template&id=608c3ae2&scoped=true"
import script from "./CustomerFilterPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerFilterPanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CustomerFilterPanel.vue?vue&type=style&index=0&id=608c3ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608c3ae2",
  null
  
)

export default component.exports